module.exports = __webpack_public_path__ + "img/N330-1-EN.1fdd355f.png";